import { render, staticRenderFns } from "./ReportingVideos.vue?vue&type=template&id=0f7e0e02&scoped=true"
import script from "./ReportingVideos.vue?vue&type=script&lang=js"
export * from "./ReportingVideos.vue?vue&type=script&lang=js"
import style0 from "./ReportingVideos.vue?vue&type=style&index=0&id=0f7e0e02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e0e02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f7e0e02')) {
      api.createRecord('0f7e0e02', component.options)
    } else {
      api.reload('0f7e0e02', component.options)
    }
    module.hot.accept("./ReportingVideos.vue?vue&type=template&id=0f7e0e02&scoped=true", function () {
      api.rerender('0f7e0e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting-web/ReportingVideos.vue"
export default component.exports